import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'confirm-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent implements OnInit {

  @Input() public showDialog: boolean;
  @Input() public dialogType: string;
  @Input() public message: string;
  @Output() public onDialogConfirm = new EventEmitter<any>();
  @Output() public onDialogClose = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  public confirm(): void {
    this.onDialogConfirm.emit();
  }

  public cancel(): void {
    this.onDialogClose.emit();
  }

}
